<template>
  <v-validate-observer ref="gForm">
    <slot name="body" />
  </v-validate-observer>
</template>
<script>
export default {
  methods: {
    validate() {
      return this.$refs.gForm.validate();
    },
    reset() {
      this.$refs.gForm.reset();
    },
  },
};
</script>
